import { useEffect } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";

import SidebarComponent from "../../components/sidebar/SidebarComponent";
import SessionManager from "../../components/session/SessionManager";
import "./index.scss";

export default function HomePage({ login }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  useEffect(() => {
    if (!login && !isLoginPage) {
      navigate("/login", { replace: true });
    } else if (login && location.pathname === "/") {
      navigate("/dashboard", { replace: true });
    }
  }, [isLoginPage, location.pathname, login, navigate]);

  if (!login && !isLoginPage) {
    return null;
  }

  return (
    <>
      {login && !isLoginPage ? <SessionManager /> : null}
      {isLoginPage ? (
        <main className="h-screen w-screen bg-zinc-50">
          <div style={{ width: "100%" }}>
            <Outlet />
          </div>
        </main>
      ) : (
        <main className="dashboard-shell flex h-screen">
          <div className="flex-shrink-0 h-full">
            <SidebarComponent />
          </div>
          <div className="dashboard-main flex-1 overflow-y-auto">
            <div className="dashboard-page">
              <Outlet />
            </div>
          </div>
        </main>
      )}
    </>
  );
}
